import { isRecord } from './record.helper';

/**
 * Narrowing helpers for caught errors, which are `unknown`.
 *
 * HttpClient rejects with an `HttpErrorResponse`, whose parsed response body
 * is in `.error`; other failures are usually `Error`s. Both expose `.message`.
 */

/** The string `message` of an `Error`, `HttpErrorResponse` or similar. */
export function errorMessage(error: unknown): string | undefined {
  const message = isRecord(error) ? error['message'] : undefined;
  return typeof message === 'string' ? message : undefined;
}

/** The parsed response body of an `HttpErrorResponse`-shaped error. */
export function errorBody(error: unknown): unknown {
  return isRecord(error) ? error['error'] : undefined;
}

/**
 * A string field of the error response body, such as the API's
 * `{ "message": "..." }` or `{ "detail": "..." }`.
 */
export function errorBodyString(
  error: unknown,
  field: string
): string | undefined {
  const body = errorBody(error);
  const value = isRecord(body) ? body[field] : undefined;
  return typeof value === 'string' ? value : undefined;
}

/**
 * Whether a request failed because the session could not be authenticated:
 * the API rejected it with a 401, or no access token could be obtained. The
 * HTTP interceptors have already sent the user through reauthentication.
 */
export function isAuthFailure(error: unknown): boolean {
  return isRecord(error) && error['status'] === 401;
}
